import { useEffect, useRef, useState } from "react";

/**
 * Hook to create an intersection observer.
 * @returns { observerRef, isIntersecting }
 */
export const useIntersectionObserver = (rootMargin = "0px", root?: Element | null, threshold = 1) => {
  const observerRef = useRef<HTMLDivElement>(null);
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    const { current: node } = observerRef;
    if (!node) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setIsIntersecting(entry.isIntersecting);
        });
      },
      { rootMargin, threshold, root }
    );
    observer.observe(node);

    return () => {
      if (node) {
        observer.unobserve(node);
      }
    };
  }, [observerRef, rootMargin, threshold, setIsIntersecting, root]);
  return { observerRef, isIntersecting };
};
